<template>
    <Providers :AllowEdit="true"/>
</template>

<script>
import Vue from 'vue'; 
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
import Providers from '@/components/DPEBB/Administrator/Providers.vue';
export default {

data: function (){
        return{
                AppServiceID :6,
        }
      },
    components: { 
        Providers
    },

created: function() { 
    this.$emit('update:layout', LayoutDefault);
},    
beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    }
}

</script>


<style>

</style>
